<!--新闻中心-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
        </div>
        <div class="top-container">
            <div class="flex-item new-icon">
                <svg t="1743558957608" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2655" width="25" height="25"><path d="M410.5664 1015.68l29.888 0c8 0 14.464-6.464 14.528-14.464 0.128-45.696 0.448-184.64-0.064-197.056-0.576-14.912 5.888-31.168 12.352-38.72 5.952-6.976 419.648-489.024 484.096-564.16 2.304-2.688 6.592-0.576 5.952 2.88-18.304 93.568-131.776 673.6-133.44 681.92-1.408 7.04-5.952 9.984-12.352 7.936-6.848-2.24-229.824-71.68-278.72-86.912-5.248-1.6-10.816 1.216-12.48 6.464l-8 24.192c-1.728 5.312 1.152 11.008 6.528 12.672 48.064 15.104 259.584 81.472 283.136 88.512 29.184 8.704 59.52-10.112 65.728-43.264 5.12-27.328 144-734.208 146.048-746.944 2.048-12.736 5.248-34.752-6.784-43.328-19.008-13.504-36.352-7.552-42.496-3.136-0.64 0.448-1.472 0.512-2.176 0.896l-3.2 1.792c0 0-900.16 480.64-932.288 497.984-32.128 17.28-30.656 53.76-3.776 62.528 23.936 7.744 240.896 78.208 289.216 93.888 5.248 1.728 10.944-1.152 12.608-6.464l7.68-23.552c1.728-5.248-1.216-10.944-6.464-12.672l-236.736-76.16c-8.448-2.688-9.472-14.208-1.664-18.368l808.256-432.576c2.304-1.216 4.608 1.6 2.88 3.584-60.928 71.04-442.56 515.584-459.648 535.232-18.496 21.312-28.928 43.52-28.928 71.616C410.3104 828.096 410.5664 1015.68 410.5664 1015.68L410.5664 1015.68M410.5664 1015.68" fill="#ff7f2e" p-id="2656"></path><path d="M440.4544 1018.432l-32.64 0-0.256-218.496c-0.064-26.816 9.344-50.112 29.568-73.408 16.576-19.072 381.056-443.712 458.176-533.504l-806.272 431.552c-3.136 1.664-4.032 4.736-3.776 7.04 0.192 2.304 1.664 5.184 4.992 6.272l236.736 76.16c3.264 1.024 5.888 3.328 7.488 6.336 1.536 3.072 1.856 6.528 0.768 9.792l-7.68 23.616c-2.176 6.72-9.408 10.368-16.128 8.192l-289.216-93.888c-12.672-4.096-20.864-14.144-22.08-26.944-1.408-15.872 8.256-31.424 25.344-40.64 31.744-17.088 923.264-493.12 932.288-497.984l3.136-1.728c0.576-0.32 1.088-0.448 1.472-0.576 7.488-5.248 26.24-11.136 46.144 3.008 13.76 9.728 9.792 34.24 7.936 46.016-1.152 7.296-46.72 239.68-86.912 444.736-30.528 155.904-56.96 290.56-59.136 302.272-3.2 17.152-12.608 31.36-26.56 39.872-12.928 7.936-28.096 9.856-42.624 5.504-22.016-6.592-205.376-64.064-283.136-88.512-3.264-1.024-5.952-3.264-7.552-6.336-1.6-3.072-1.856-6.592-0.768-9.856l8-24.192c2.176-6.592 9.344-10.304 15.936-8.192l10.112 3.136c64.832 20.224 262.144 81.728 268.608 83.776 2.24 0.704 4.096 0.64 5.504-0.192 1.984-1.152 2.88-3.712 3.264-5.696 1.088-5.568 52.352-267.584 91.584-468.16l41.856-213.76c0-0.128 0.064-0.512-0.32-0.704-0.448-0.192-0.704 0.064-0.768 0.192-64.448 75.136-478.144 557.184-484.096 564.16-6.144 7.168-12.224 22.912-11.712 36.864 0.448 12.672 0.128 154.112 0.064 197.12C457.7344 1010.752 449.9264 1018.432 440.4544 1018.432zM413.3184 1012.928l27.136 0c6.464 0 11.712-5.248 11.712-11.712 0.064-30.592 0.448-184-0.064-196.928-0.576-15.872 6.272-32.768 12.992-40.64 6.016-6.976 419.648-489.024 484.096-564.16 1.856-2.176 4.8-2.752 7.36-1.536 2.56 1.216 3.904 3.968 3.392 6.72l-41.856 213.76c-39.232 200.576-90.496 462.528-91.648 468.16-0.832 4.416-2.88 7.616-5.888 9.408-2.816 1.664-6.272 1.856-10.048 0.64-6.464-2.048-203.712-63.552-268.608-83.776l-10.112-3.136c-3.776-1.216-7.808 0.896-9.024 4.672l-8 24.192c-0.64 1.856-0.448 3.84 0.448 5.568 0.896 1.728 2.432 3.008 4.288 3.584 60.672 19.072 260.48 81.728 283.072 88.448 13.056 3.904 26.56 2.112 38.144-4.928 12.608-7.68 21.12-20.544 24.064-36.16 2.176-11.776 28.608-146.432 59.136-302.336 40.192-204.992 85.696-437.312 86.848-444.544 1.728-10.688 5.248-32.896-5.632-40.64-17.344-12.352-33.28-7.488-39.296-3.136-0.704 0.512-1.408 0.768-1.984 0.896l-3.648 1.92c-9.024 4.8-900.544 480.832-932.288 497.984-18.048 9.728-23.424 24.576-22.464 35.264 0.96 10.496 7.744 18.752 18.24 22.144l289.216 93.888c3.776 1.216 7.872-0.832 9.152-4.672l7.68-23.616c0.576-1.856 0.448-3.84-0.448-5.568-0.896-1.728-2.368-3.008-4.224-3.584l-236.736-76.16c-4.992-1.6-8.384-5.824-8.832-11.008-0.448-5.184 2.112-9.984 6.72-12.416l808.256-432.576c2.24-1.216 4.864-0.64 6.4 1.28 1.6 1.984 1.536 4.672-0.128 6.528-73.856 86.016-443.008 516.032-459.648 535.232-19.584 22.528-28.288 44.032-28.224 69.76L413.3184 1012.928z" fill="#ff7f2e" p-id="2657"></path></svg>
            </div>
            <div class="flex-item new-title">工作室动态</div>
            <div class="flex-item new-type">
            </div>
        </div>
        <div class="page-info-container">
            <div class="group-article-one"  v-for="item in dataList" :key="item" @click="handleViewStudioNews(item)">
                <div class="group-article-name">{{item.title}}</div>
                <div class="group-article-belong">
                    {{item.groupName}}
                </div>
            </div>
            <data-empty v-if="dataList&&dataList.length===0" title="暂无动态"/>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[10, 20, 30]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageAllStudioInfo" />
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {pageStudioInfo} from "@/api/admin/studio";
export default {
    components: {
        pageTag, dataEmpty,
        homeHead,
    },
    name: "homeNewsCentre",
    data() {
        return {
            timestampToTime,
            activePath: "homeNewsCentre",
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                type:2,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            newType:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageAllStudioInfo()
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        pageAllStudioInfo(){
            pageStudioInfo(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleViewStudioNews(item){
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/jzedu/studionews",
                query: {
                    signno: item.infoId,
                }
            });
            window.open(routeUrl.href, '_blank')
        },
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
    }
}
.top-container{
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #fff;
    padding-left: 20px;
    box-sizing: border-box;
}
.new-title{
    width: 200px;
    height: 40px;
    line-height: 45px;
    font-size: 16px;
    color: #ff7f2e;
    font-weight: bold;
}
.new-icon{
    padding-right: 5px;
    margin-top: 8px;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
/*工作室动态*/
.group-trends-box{
    width: 98%;
    height: auto;
    background-color: #fff;
    margin-top: 20px;
}
.group-article-one{
    display: flex;
    width: 98%;
    margin: auto;
    height: 36px;
    border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-article-name{
    line-height: 36px;
    font-size: 15px;
    width: calc(100% - 240px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #ff7f2e;
}
.group-article-belong{
    width: 240px;
    line-height: 36px;
    text-align: right;
    color: #cecece!important;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.new-type{
    padding-right: 40px;
    box-sizing: border-box;
}

.flex-item:last-child{
    margin-left: auto;
}
</style>